'use client'
/***
 *
 * @file components/Stepper/index.tsx
 * @description Stepper component will be used for rendering the content.
 * @author Ayesha Kumar
 * @organization Truminds Software System
 * @since 7 Jan 2026
 *
 */

import React, { ReactNode, SetStateAction, useEffect, useRef, useState } from "react";
// import "./Stepper.scss";

type Props = {
  id?: string,
  children: ReactNode
}


const Stepper = ({ id, children }: Props) => {

  const steps = React.Children.toArray(children);
  const isInContentfulStudio = (typeof window !== "undefined") && window.self !== window.top;
  const [currentStep, setCurrentStep] = useState<number>(0);
  const stepperRef = useRef<HTMLDivElement | null>(null)

  const increaseStep = (e: Event) => {
    e?.stopPropagation();
    setCurrentStep(c => c < (steps?.length - 1) ? c + 1 : c)

  };

  const decreaseStep = (e: Event) => {
    e?.stopPropagation();
    setCurrentStep(c => c > 0 ? c - 1 : c);
  };

  useEffect(() => {
    setCurrentStep(0);
    
    stepperRef?.current?.addEventListener("next_step", increaseStep);
    stepperRef?.current?.addEventListener("prev_step", decreaseStep);

    return () => {
      stepperRef?.current?.removeEventListener("next_step", increaseStep);
      stepperRef?.current?.removeEventListener("prev_step", decreaseStep);
    }
  }, [])


  return (
    <div className="Stepper-container" style={{height: "100%"}} id={id} ref={stepperRef} data-testid="Stepper">
      {isInContentfulStudio ? children : steps[currentStep]}
    </div>
  );
};

export default Stepper;
